import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Collapse from "@mui/material/Collapse";

const ReferencesItem = ({ item, descriptions }) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(prev => !prev);
  };

  const renderDescription = (desc) => {
    const linkify = (text) => {
      const urlRegex = /(https?:\/\/\S+)/g;
      return text.split(urlRegex).map((part, index) => {
        if (part.match(urlRegex)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline text-sm sm:text-base break-words"
            >
              {part}
            </a>
          );
        }
        return part;
      });
    };

    if (desc.description.includes("*")) {
      const parts = desc.description.split("\n").filter(line => line.trim() !== "");
      const mainText = parts[0];
      const listItems = parts.slice(1);

      return (
        <div className='text-sm sm:text-base'>
          <div>{linkify(mainText)}</div>
          <ul className="list-disc ml-6 space-y-0.5">
            {listItems.map((item, index) => (
              <li key={index}>{linkify(item.replace("* ", ""))}</li>
            ))}
          </ul>
        </div>
      );
    }

    return (
      <div className='text-sm sm:text-base'>
        {linkify(desc.description)}
      </div>
    );
  };

  return (
    <div>
      <div className="flex flex-row items-center py-4 px-12 bg-gray-50 hover:bg-gray-200 cursor-pointer border shadow ease-in-out duration-150 rounded-full" onClick={handleToggle}>

        <IconButton size="small">
          {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
        </IconButton>
        <p>{item}</p>
      </div>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <div className="text-gray-700 bg-white px-6 py-4 border-gray-200 flex flex-col gap-y-4">
          {descriptions?.map((desc, idx) => (
            <div key={idx}>
              <strong>{desc.title}</strong>
              {renderDescription(desc)}
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

export default ReferencesItem;
